module.exports = __webpack_public_path__ + "img/book.d5b07250.png";